export const DISPLAY_TIME_PERFORMANCE = 'GRAPH'
export const DISPLAY_SAVINGS = 'NUMPERCENT'



// WEBPACK FOOTER //
// ./src/constant/page/dashboard.js